// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import './assets/resetcss.css'
import './assets/common.css'
import App from './App'
import router from './router'
import {
  Row,
  Col,
  Tabs,
  TabPane,
  Menu,
  Submenu,
  MenuItem,
  Input,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Dialog,
  Button,
  Option,
  Form,
  FormItem,
  Select,
  Message,
  Table,
  TableColumn,
  Tooltip,
  Tree,
  Timeline,
  TimelineItem,
  Pagination,
  Radio,
  RadioGroup,
  RadioButton,
  DatePicker,
  Loading,
  Image,
  Card,
  Carousel,
  CarouselItem,
  Checkbox,
  Tag,
  MessageBox
} from 'element-ui'
import axios from 'axios'
import {Base64} from 'js-base64'

Vue.use(Row)
Vue.use(Col)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(Input)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Dialog)
Vue.use(Button)
Vue.use(Option)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Select)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Tooltip)
Vue.use(Tree)
Vue.use(Timeline)
Vue.use(TimelineItem)
Vue.use(Pagination)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(RadioButton)
Vue.use(DatePicker)
Vue.use(Loading)
Vue.use(Image)
Vue.use(Card)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Checkbox)
Vue.use(Tag)

Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$Base64 = Base64;
Vue.prototype.$message = Message

Vue.config.productionTip = false
Vue.prototype.$axios = axios
axios.defaults.baseURL = '/api'


const globalEvents = ['cut','copy','paste','contextmenu','print'];//禁用剪切、复制、粘贴、右键菜单、页面打印事件。
globalEvents.forEach((eventName) => {
  document.addEventListener(eventName,function(e){
    e.preventDefault()
  })
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js